import { createFileRoute } from "@tanstack/react-router";
import { Login } from "@/features/auth";

const Route = createFileRoute("/_public/login/")({
  component: () => <Login />,
});

export { Route };
